<template>
  <div>{{  _.get(trItem.stock, 'costo', '0') | arrotonda }} €</div>
</template>

<script>
import { EventBus } from "../main.js";
import { db } from "@/components/Firebase_Conn";
import { ref } from "@/components/puntatori";

export default {
  name: "crudTableMagazzinoCosto",
  props: ["trItem"],
  directives: {},
  data() {
    return {
      //VARIABILI AMBIENTE
    };
  },
  methods: {},
  mounted() {},
  watch: {},
  filters: {
    arrotonda: function(str) {
      let numero = str;

      numero = parseFloat(numero).toFixed(2);
      numero = numero.toString();
      numero = numero.replace(".", ",");
      return numero;
    }
  }
};
</script>

<style scoped>
</style>
